<template>
  <div
    class="brand-page"
  >
    <!-- 背景 -->
    <van-image
      width="10rem"
      :height="showSubNav ? 'calc(100vh - 98px)' : 'calc(100vh - 54px)'"
      class="abs animated1s fadeIn"
      style="z-index: 0;"
      :src="require('@/imgs/index/brand/bg.png')"
      :show-error="false"
      :show-loading="false"
    />
    <!-- 一级菜单 -->
    <div
      class="abs-b menu-view flx-ctr animated1s fadeInLeft"
      style="z-index: 2003;"
    >
      <div class="menu flx-ctr">
        <van-image
          :src="activeNav === 0 ? require('@/imgs/index/brand/shili_h.png') : require('@/imgs/index/brand/shili_n.png')"
          width="44px"
          :show-error="false"
          :show-loading="false"
          class="icon"
          @click="acNavChange(0)"
        />
        <van-image
          :src="activeNav === 1 ? require('@/imgs/index/brand/chengjiu_h.png') : require('@/imgs/index/brand/chengjiu_n.png')"
          width="44px"
          :show-error="false"
          :show-loading="false"
          class="icon"
          @click="acNavChange(1)"
        />
      </div>
    </div>
    <!-- 二级菜单 -->
    <!-- 导航 -->
    <div
      :class="`sub-menu-view animated1s`"
      :style="`opacity: ${showSubNav ? '1' : '0'}`"
    >
      <div style="width: 10rem;height: 30px" />
      <div :class="`menu animated1s ${showSubNav ? 'fadeInLeft' : 'fadeOutLeft' }`">
        <div
          v-for="(item, index) in NAV_INFO"
          :id="`nav-${item.id}`"
          :key="`nav-${index}`"
          class="icon-view flx-ctr"
          @click="navChange(item.id)"
        >
          <van-image
            :src="item.nIcon"
            :width="`${item.nWidth || item.width}px`"
            :height="`${item.nHeight}px`"
            :show-error="false"
            :show-loading="false"
            class="icon"
          >
            <van-image
              v-if="current === item.id"
              :src="item.hIcon"
              :width="`${item.width}px`"
              :height="`${item.height}px`"
              :show-error="false"
              :show-loading="false"
              class="abs icon"
              style="top: -73%;left:-27%"
            />
          </van-image>
        </div>
      </div>
    </div>
    <div class="left-tips abs-b flx-row-btw">
      <span style="margin-left: 12px">&lt;&lt;</span>
      <span>左右滑动查看更多</span>
      <span style="margin-right: 12px">>></span>
    </div>
    <!-- logo -->
    <van-image
      width="1rem"
      class="abs-b-r"
      :style="`bottom: ${showSubNav ? 'calc(3.5vh + 44px)' : '3.5vh'};right: .5rem`"
      :src="require('@/imgs/index/brand/logo.png')"
      :show-error="false"
      :show-loading="false"
    />
    <!-- 内容 -->
    <van-swipe
      ref="swiper"
      class="content-info-view"
      vertical
      :show-indicators="false"
      :loop="true"
      :width="clientWidth"
      @change="swiperChange"
    >
      <van-swipe-item>
        <van-swipe
          ref="brand-swiper1"
          class="brand-swiper"
          :autoplay="0"
          :loop="true"
          :show-indicators="false"
          @change="currentChange"
        >
          <van-swipe-item
            v-for="(item, index) in BOOK_INFO[0]"
            :key="index"
            class="swiper-item flx-col-arn"
            height="calc(100vh - 54px)"
          >
            <template v-if="current == item.id">
              <template v-for="(info, i) in item.info">
                <van-image
                  v-if="info.type === 'img'"
                  :key="`item-${i}`"
                  :src="info.src"
                  :width="info.width"
                  :show-error="false"
                  :show-loading="false"
                  :class="`${info.ani}`"
                  :style="`margin: ${info.mtop || 0} ${info.mright || 0} ${info.mbottom || 0} ${info.mleft || 0}`"
                />
                <div
                  v-else-if="info.type === 'line'"
                  :key="`item-${i}`"
                  class="animated1s fadeIn delay0d5s line-view flx-ctr"
                >
                  <span
                    class="line"
                  />
                </div>
                <div
                  v-else-if="info.type === 'block'"
                  :key="`item-${i}`"
                  :style="`width: 10rem;height: ${info.height};`"
                />
              </template>
            </template>
          </van-swipe-item>
        </van-swipe>
      </van-swipe-item>
      <van-swipe-item>
        <van-swipe
          ref="brand-swiper"
          class="brand-swiper"
          indicator-color="white"
          :autoplay="0"
          :loop="true"
          @change="currentChange"
        >
          <van-swipe-item
            v-for="(item, index) in BOOK_INFO[1]"
            :key="index"
            class="swiper-item flx-col-arn"
            height="calc(100vh - 54px)"
          >
            <!-- 内容图片 -->
            <template v-for="(info, i) in item.info">
              <van-image
                v-if="info.type === 'img'"
                :key="`item-${i}`"
                :src="info.src"
                :width="info.width"
                :show-error="false"
                :show-loading="false"
                :class="`${info.ani}`"
                style="margin: 10px 0"
              />
              <div
                v-else-if="info.type === 'line'"
                :key="`item-${i}`"
                class="animated1s fadeIn delay0d5s line-view flx-ctr"
              >
                <span
                  class="line"
                />
              </div>
              <div
                v-else-if="info.type === 'block'"
                :key="`item-${i}`"
                :style="`width: 10rem;height: ${info.height};`"
              />
            </template>
          </van-swipe-item>
        </van-swipe>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import { BOOK_INFO, NAV_INFO } from '@/libs/config/brand';
import { Swipe, SwipeItem } from 'vant';

export default {
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
  },
  data() {
    return {
      NAV_INFO,
      BOOK_INFO,
      current: -1,
      activeNav: 0,
      clientWidth: 0,
    };
  },
  computed: {
    showSubNav() {
      return this.activeNav === 0;
    },
  },
  mounted() {
    // 正确设置swiper宽度
    this.clientWidth = document.body.clientWidth;
  },
  methods: {
    currentChange(index) {
      this.current = index - 1;
      if (this.current < 3) {
        this.scrollIntoView(0);
      } else {
        this.scrollIntoView(7);
      }
      // console.log(this.current);
      // document.getElementById(`nav-${this.current}`).scrollIntoView({ behavior: 'smooth', inline: 'end' });
      // this.navChange(index);
    },
    navChange(id) {
      this.current = id + 1;
      if (this.current < 3) {
        this.scrollIntoView(0);
      } else {
        this.scrollIntoView(7);
      }
      this.$refs['brand-swiper1'].swipeTo(this.current);
    },
    // 一级菜单
    acNavChange(id) {
      this.activeNav = id;
      this.$refs.swiper.swipeTo(id);
      // this.scrollIntoView(id);
    },
    // 内容滚动
    swiperChange(index) {
      this.activeNav = index;
      if (index < 3) {
        this.scrollIntoView(1);
      } else {
        this.scrollIntoView(6);
      }
    },
    scrollIntoView(id) {
      this.$nextTick(() => {
        document.getElementById(`nav-${id}`).scrollIntoView({ behavior: 'smooth', inline: 'end' });
      });
    },
  },
};
</script>

<style lang="less" scope>
.brand-page {
  position: relative;
  width: 10rem;
  height: calc(100vh - 54px);
  background-color: #fefefe;
  background-size: cover;
  overflow: hidden;
  .menu-view {
    bottom: calc(1vh + 54px);
    width: 100%;
    height: 50px;
    padding: 5px;
    z-index: 2;
    .menu {
      padding: 6px 12px;
      background-color: #231f1d;
      border-radius: 50px;
      .icon {
        margin-right: 12px;
        line-height: 60px;
        &:last-child {
          margin: 0;
        }
      }
    }
  }
  .left-tips {
    width: 10rem;
    font-size: 8px;
    color: rgba(255, 255, 255, .4);
    bottom: 4px;
    z-index: 2002;
  }
  .sub-menu-view {
    position: absolute;
    width: 10rem;
    bottom: 0;
    left: 0;
    overflow-x: scroll;
    overflow-y: hidden;
    z-index: 2001;
    transition: all .5s linear;
    background-image: linear-gradient(to right , #212125, #212125);
    background-size: 100% 60px;
    background-position: 0% 100%;
    background-repeat: no-repeat;
    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
    .menu {
      width: 10rem;
      height: 46px;
      margin-bottom: 12px;
      white-space: nowrap;
    }
    .icon-view {
      display: inline-block;
      margin: 3px 10px 5px 10px;
    }
    .more {
      width: 100%;
      padding: 5px 0;
      background-color: #212125;
      margin-top: -1px;
      transition: width .5s linear;
      &.hide {
        width: 54px;
        height: 44px;
        padding: 0;
        margin-left: -22px;
        border-radius: 22px;
        & .van-image {
          margin-left: 16px;
          transform: rotate(180deg);
        }
      }
    }
  }
  .custom-indicator {
    position: absolute;
    z-index: 10;
    right: .5rem;
    top: 25vh;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    div {
      margin-bottom: 12px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .select-dot {
      position: absolute;
      left: 0;
      top: 54px;
      width: 10px;
      height: 10px;
      border-radius: 50px;
      background-color: #f2a434;
      transition: top .5s ease-in-out;
    }
  }
  .content-info-view {
    width: 10rem;
    height: calc(100% - 44px);
  }
  .brand-swiper {
    width: 10rem;
    height: 100%;
  }
  .swiper-item {
    width: 10rem;
    height: 100%;
    .line-view {
      // height: 6vh;
      .line {
        position: relative;
        width: 8rem;
        height: 1px;
        background-color: #737373;
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: -100%;
          width: 10%;
          height: 200%;
          background-color: #737373;
          border-radius: 1px;
        }
        // &::after {
        //   content: '业务模块';
        //   position: absolute;
        //   right: 0;
        //   top: -14px;
        //   font-size: 12px;
        //   font-weight: bold;
        //   height: 200%;
        //   color: #737373;
        //   border-radius: 1px;
        // }
      }
    }
  }
  .title {
    margin-top: 3vh;
  }
  .content {
    margin-top: 3vh;
  }
  .foot {
    margin-top: 4vh;
  }
}
</style>
